import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "personal-kyc-status",
  data() {
    return {
      isRequesting: false
    };
  },
  computed: {
    ...mapGetters({
      userVerify: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),

    rejectReason() {
      return this.userVerify?.verification_image?.reject_reason;
    },

    status() {
      return this.userVerify?.kyc_step;
    },

    isApprove() {
      return this.status === "FULL_VERIFIED";
    },

    isPending() {
      return this.status === "USER_IDENTITY_PROCESSING";
    },

    isReject() {
      return this.status === "USER_IDENTITY";
    },

    hasIdentity() {
      return this.userVerify?.personal_information_status !== null;
    }
  },
  methods: {
    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },
    goToTypeSelection() {
      this.$router.push({ name: "typeSelection" });
    }
  }
};
